import { render, staticRenderFns } from "./ReservedBookInfo.vue?vue&type=template&id=3bb188c0&scoped=true&"
import script from "./ReservedBookInfo.vue?vue&type=script&lang=js&"
export * from "./ReservedBookInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReservedBookInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReservedBookInfo.vue?vue&type=style&index=1&id=3bb188c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb188c0",
  null
  
)

export default component.exports